export enum UserRole {
  ADMIN = "ADMIN",
  SUPER_ADMIN = "SUPER_ADMIN",
  PARTNER_ADMIN = "PARTNER_ADMIN",
}
